@if (dateSigned) {
  {{ dateSigned | valueByTypePipe : DataTypeEnum.DateTime }}
}
@if (!dateSigned && deadline) {
  {{ deadline | valueByTypePipe : DataTypeEnum.DateTime }}
}
@if (!dateSigned && !deadline && deadlineDays) {
  @if (deadlineDays === 1) {
    <span translate="Request.Status.DaysToReadableText.Selected_Day"
      [translateParams]="{days: deadlineDays}">
    </span>
  }
  @if (deadlineDays > 1 && deadlineDays < 31) {
    <span
      translate="Request.Status.DaysToReadableText.Selected_Days"
      [translateParams]="{days: deadlineDays}">
    </span>
  }
  @if (deadlineDays === 31) {
    <span translate="Request.Status.DaysToReadableText.Selected_Month"
      [translateParams]="{month: 1}">
    </span>
  }
  @if (deadlineDays > 31) {
    <span translate="Request.Status.DaysToReadableText.Selected_Months"
      [translateParams]="{months: deadlineDays === 62 ? 2 : 3}">
    </span>
  }
}